import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { SITE_URL } from '../../api';
import './PublicBreadcrumb.scss';

// Breadcrumb for the public pages (legal, help, product directory): home icon, chevrons, the
// current page last (not a link). Also emits the schema.org BreadcrumbList so search engines
// can show the trail in results.
// items: [{ label, to? }] after the home entry — the last one is the current page.
// maxWidth / gutter: align the trail with the page's own content column.
const PublicBreadcrumb = ({ items = [], maxWidth, gutter, className = '', style }) => {
    const { i18n } = useTranslation();
    const home = `/${i18n.language}`;

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{ label: 'Accueil', to: home }, ...items].map((item, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            name: item.label,
            ...(item.to ? { item: `${SITE_URL}${item.to}` } : {}),
        })),
    };

    return (
        <nav className={`pub-crumbs ${className}`} style={style} aria-label="Fil d'Ariane">
            <ol className="pub-crumbs__list" style={{ maxWidth, paddingInline: gutter }}>
                <li className="pub-crumbs__item">
                    <NavLink to={home} className="pub-crumbs__home" aria-label="Accueil" title="Accueil">
                        <FontAwesomeIcon icon={faHouse} />
                    </NavLink>
                </li>
                {items.map((item, i) => {
                    const last = i === items.length - 1;
                    return (
                        <li key={i} className="pub-crumbs__item">
                            <FontAwesomeIcon icon={faChevronRight} className="pub-crumbs__sep" aria-hidden="true" />
                            {last || !item.to ? (
                                <span className="pub-crumbs__current" aria-current={last ? 'page' : undefined} title={item.label}>
                                    {item.label}
                                </span>
                            ) : (
                                <NavLink to={item.to} className="pub-crumbs__link">{item.label}</NavLink>
                            )}
                        </li>
                    );
                })}
            </ol>
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </nav>
    );
};

export default PublicBreadcrumb;
